import { action } from 'satcheljs';
import { CalendarId } from 'owa-calendar-cache';

let setCalendarId = action('setCalendarId', (calendarId: CalendarId) => ({
    calendarId: calendarId,
}));

export default setCalendarId;
